var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NodeElement } from './node-element';
var ConditionalEnableNodeElement = /** @class */ (function (_super) {
    __extends(ConditionalEnableNodeElement, _super);
    function ConditionalEnableNodeElement(injector) {
        return _super.call(this, injector) || this;
    }
    ConditionalEnableNodeElement.prototype.build = function (part, svg) {
        var model = _super.prototype.build.call(this, part, svg);
        this.buildConditionalEnableData(model, part.data);
        return model;
    };
    ConditionalEnableNodeElement.prototype.buildConditionalEnableData = function (model, data) {
        // conditional enable
        model['isAwaysEnable'] = data.isAwaysEnable;
        if (!data.isAwaysEnable) {
            model['isEnableControl'] = data.logicalControlEnabled;
            model['enableItems'] = data.enableItems;
            if (data.permissionsForEnableSetting) {
                model['isEnablePermission'] = data.permissionsForEnableSetting.PermissionEnabled;
                model['enablePermissionCodes'] = data.permissionsForEnableSetting.PermissionList;
            }
        }
    };
    return ConditionalEnableNodeElement;
}(NodeElement));
export { ConditionalEnableNodeElement };
